import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CustomValidators, TokenService, Utils } from 'viggo-sistemas-core-web';

import { DataDialogEditPrecoProduto } from '@app/modules/produto/components';
import { IProdutoPreco } from '@app/modules/produto/model';
import { TabelaPrecoService } from '@app/modules/tabelapreco/services';
// import { ITabelaPreco } from '@app/modules/tabelapreco/model';

@Component({
  selector: 'app-fast-preco-produto',
  templateUrl: './fast-preco-produto.component.html',
  styleUrls: ['./fast-preco-produto.component.scss'],
  providers: [TabelaPrecoService]
})
export class FastPrecoProdutoComponent implements OnInit {
  form: UntypedFormGroup;
  domain_id: string;

  constructor(
    private fb: UntypedFormBuilder,
    public tabelaPrecoService: TabelaPrecoService,
    protected tokenService: TokenService,
    protected dialogRef: MatDialogRef<FastPrecoProdutoComponent, IProdutoPreco>,
    @Inject(MAT_DIALOG_DATA)
    public data: DataDialogEditPrecoProduto,
  ) {}

  ngOnInit(): void {
    this.domain_id = this.tokenService.getDomain().id;
    const { preco: precoProduto } = this.data;
    this.form = this.fb.group({
      valor: [
        precoProduto.valor || 0,
        [
          Validators.required,
          CustomValidators.validateEqualsMinZero(),
          CustomValidators.validateCurrencyValues(15,3),
          CustomValidators.existSpecialChar(true)
        ]
      ],
      tabela_preco: [
        precoProduto.tabela_preco,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  salvar(): void {
    const preco: IProdutoPreco = {
      ...this.data.preco,
      ...this.form.value
    };
    preco.valor = Utils.replaceCommaToDot(preco.valor);
    preco.tabela_preco_id = preco.tabela_preco.id;

    this.dialogRef.close(preco);
  }
  // filterTabelaDisponiveis(tabelas: ITabelaPreco[]): ITabelaPreco[] {
  //   if (!tabelas) return [];

  //   const { tabelasSelecionadas, preco: precoProduto } = this.data;
  //   return tabelas.filter(
  //     tabela =>
  //       tabela.id === precoProduto.tabela_preco_id ||
  //       !tabelasSelecionadas.includes(tabela.id)
  //   );
  // }
}
